import { Environments } from '@product/cabify-environments';

import { type ApplicationConfig } from './index';

export const config: ApplicationConfig = {
  appEnv: Environments.PRODUCTION,
  url: {
    apiBase: 'https://support.cabify.com/support/api',
  },
};
